var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.showComponent)?_c('CompensationSelection',{on:{"next-form":_vm.formSubmited}}):_vm._e(),(_vm.showComponent)?_c('DynamicFormCompensation',{attrs:{"proposalOption":_vm.selectedOptions,"passengerList":_vm.passengerData,"milesPassengerList":_vm.passengerDataMiles}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }